module.exports = __webpack_public_path__ + "img/mini-028.c5a97774.jpg";